module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-rdu.jpg?v=0b713d58";